/**
 * 存放pc端各页面url常量
 */
export const HOME_PAGE = '/'; // 首页
export const COURSE_HOME = '/college'; // 在线学习页
export const ZONE_HOME = '/zone'; // 专区首页
export const SOFTWARE_DOWNLOAD = '/college/software'; // 软件下载页
export const LECTURER_APPLY = '/activity/findLecturer'; // 讲师申请页
export const CONTACT_US = '/contact-us'; // 联系我们
export const ABOUT_US = '/about-us'; // 关于我们
export const XINGTAN_INDEX = '/college/xingtan'; // 杏坛首页
